var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", { attrs: { title: _vm.title } }, [
    _c(
      "div",
      { ref: "scrollView", staticClass: "clientsDetail" },
      [
        _c(
          "div",
          {
            staticClass: "clients-information",
            staticStyle: { "min-height": "4.5rem" }
          },
          [
            _c("div", { staticClass: "clients-information-header" }, [
              _c("img", {
                staticClass: "headerImg",
                attrs: {
                  src: _vm.basicList.custBasicInfo.headUrl
                    ? _vm.basicList.custBasicInfo.headUrl
                    : _vm.basicList.custBasicInfo.sex == 0
                    ? require("@/assets/MM.png")
                    : require("@/assets/WW.png"),
                  alt: "",
                  srcset: ""
                }
              }),
              _vm._v(" "),
              _vm.basicList.custBasicInfo.member == "10"
                ? _c("img", {
                    staticClass: "vipImg",
                    attrs: { src: require("@/assets/img/v.png"), alt: "" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "information-list" }, [
                _c("div", { staticClass: "clientName" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.basicList.custBasicInfo.custName || "") +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "phone" }, [
                  _c("img", {
                    staticClass: "phoneImg",
                    attrs: {
                      src: require("@/assets/img/phone.png"),
                      alt: "",
                      srcset: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "phone-numer" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          this.$campKit.maskMobile(
                            _vm.basicList.custBasicInfo.mobile || ""
                          )
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "telPhoneA",
                      attrs: {
                        href: "tel:" + _vm.basicList.custBasicInfo.mobile
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "telPhone",
                        attrs: {
                          src: require("@/assets/telPhone.png"),
                          alt: ""
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.hasFollowCreated && _vm.userExId != null && _vm.userAdd
                    ? _c("img", {
                        staticStyle: {
                          "margin-left": "0.2rem",
                          height: "0.5rem",
                          width: "0.5rem"
                        },
                        attrs: {
                          src: require("@/assets/img/contact.png"),
                          alt: "",
                          srcset: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.openUserProfile()
                          }
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "Vip-flex" }, [
                  _c("div", [_vm._v("VIP等级：")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "VIP-starts",
                      style: "width:" + _vm.VipNum * 0.4 + "rem"
                    },
                    _vm._l(_vm.VipNum, function(item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "start",
                        attrs: {
                          src: require("@/assets/img/vipStar.png"),
                          alt: "",
                          srcset: ""
                        }
                      })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.timeM != ""
                    ? _c("div", { staticClass: "month" }, [
                        _vm._v("（" + _vm._s(_vm.timeM) + "个月）")
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "clients-informationLists" }, [
          _c(
            "div",
            { staticClass: "messageList-header" },
            _vm._l(_vm.messageList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "messageList-item",
                  on: {
                    click: function($event) {
                      return _vm.showMessageList(index, item.key)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: item.edit == false ? item.img : item.imges,
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.relaCnt && item.cnt && _vm.cnt(item.cnt) > 0
                    ? _c("div", { staticClass: "infos" }, [
                        _vm._v(_vm._s(_vm.cnt(item.cnt)))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(item.name))])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("basicIf", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "basicIf",
                    expression: "listIndex == 'basicIf'"
                  }
                ],
                ref: "basicIf",
                attrs: {
                  data: _vm.basicList,
                  custId: this.custId,
                  hasModifyAuth: _vm.hasModifyAuth
                }
              }),
              _vm._v(" "),
              _c("Inproduct", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "Inproduct",
                    expression: "listIndex == 'Inproduct'"
                  }
                ],
                ref: "Inproduct",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("ByProduct", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "ByProduct",
                    expression: "listIndex == 'ByProduct'"
                  }
                ],
                ref: "ByProduct",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("FwNews", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "FwNews",
                    expression: "listIndex == 'FwNews'"
                  }
                ],
                ref: "FwNews",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("JnActivity", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "JnActivity",
                    expression: "listIndex == 'JnActivity'"
                  }
                ],
                ref: "JnActivity",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("JnCurriculum", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "JnCurriculum",
                    expression: "listIndex == 'JnCurriculum'"
                  }
                ],
                ref: "JnCurriculum",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("TheRecords", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "TheRecords",
                    expression: "listIndex == 'TheRecords'"
                  }
                ],
                ref: "TheRecords",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("repairHis", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "repairHis",
                    expression: "listIndex == 'repairHis'"
                  }
                ],
                ref: "repairHis",
                attrs: { custId: this.custId }
              }),
              _vm._v(" "),
              _c("JoinTab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "JoinTab",
                    expression: "listIndex == 'JoinTab'"
                  }
                ],
                attrs: {
                  isshow: _vm.listIndex == "JoinTab",
                  relaCnt: _vm.relaCnt,
                  custId: this.custId
                }
              }),
              _vm._v(" "),
              _c("TagSetUp", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listIndex == "TagSetUp",
                    expression: "listIndex == 'TagSetUp'"
                  }
                ],
                attrs: {
                  isshow: _vm.listIndex == "TagSetUp",
                  relaCnt: _vm.relaCnt,
                  custId: this.custId
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "basic-information" }, [
              _c("div", { staticClass: "basic-information-title" }, [
                _vm._v("最近信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "redactImg" })
            ]),
            _vm._v(" "),
            _vm.basicList.latelyInfo
              ? _c("div", { staticClass: "basic-information-flex" }, [
                  _c("ul", { staticClass: "basic-information-lists" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("消费门店")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.basicList.latelyInfo.deptName || "") +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("购买时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.basicList.latelyInfo.buyDate || "") +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("消费金额")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.latelyInfo.amount
                                  ? _vm
                                      .$numeral(_vm.basicList.latelyInfo.amount)
                                      .format("0,0.00")
                                  : ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("参与活动")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.basicList.latelyInfo.campName || "") +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("参与课程")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.latelyInfo.courseName || ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("联系日期")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.latelyInfo.followDate
                                  ? _vm.basicList.latelyInfo.followDate.split(
                                      " "
                                    )[0]
                                  : ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information" }, [
              _c("div", { staticClass: "basic-information-title" }, [
                _vm._v("系统信息")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "redactImg" })
            ]),
            _vm._v(" "),
            _vm.basicList.systemInfo
              ? _c("div", { staticClass: "basic-information-flex" }, [
                  _c("ul", { staticClass: "basic-information-lists" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("销售顾问")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.systemInfo.createUserName || ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("所属门店")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.systemInfo.createDeptName || ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("修改人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.systemInfo.modifyUserName || ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("修改门店")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.systemInfo.modifyDeptName || ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("创建时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.systemInfo.createTime
                                  ? _vm.basicList.systemInfo.createTime
                                  : ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("最近修改时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.basicList.systemInfo.modifyTime
                                  ? _vm.basicList.systemInfo.modifyTime
                                  : ""
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("群id")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(_vm.chatId))]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            model: {
              value: _vm.labelShow,
              callback: function($$v) {
                _vm.labelShow = $$v
              },
              expression: "labelShow"
            }
          },
          [
            _c("div", { staticClass: "label-models" }, [
              _c("div", { staticClass: "label-model-title" }, [
                _c("div", { staticClass: "label-model-titles" }, [
                  _vm._v("选择客户标签")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-label-hint" }, [
                  _vm._v("提示：单击选择，再次点击取消。")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "label-list-flex-itemAuto" },
                _vm._l(_vm.selectLabel, function(items, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "basic-label-title" }, [
                      _vm._v(_vm._s(items.typeName))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "label-list-flex-item" }, [
                      _c(
                        "div",
                        { staticClass: "label-list-flex" },
                        _vm._l(items.tagList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "select-labels-title",
                              style: "background:" + item.background,
                              on: {
                                click: function($event) {
                                  return _vm.clickLabels(index, item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.name) +
                                  "\n                  "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-cancel" }, [
                _c(
                  "div",
                  { staticClass: "button-flex-color flex-border-button" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button-flex-item",
                        on: { click: _vm.cancelLabel }
                      },
                      [_vm._v("取消")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "button-flex-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item button-active",
                      on: { click: _vm.confirmLabel }
                    },
                    [_vm._v("\n                确定\n              ")]
                  )
                ])
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-321b8b43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-321b8b43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/clientDetails.vue
// module id = null
// module chunks = 